import React from 'react'
import { Box, Typography } from '@mui/material'

const Mode1 = (props) => {
    //console.log(props)
    return (
        <Box sx={{ textAlign: 'center' }} >
            <Typography paragraph>{props.SurveyDisplayMode1Frame.NofinishedAssessmentHeadlineText}</Typography>
        </Box>

    )
}

export default Mode1